/**
 * クラウド目録（I104–I106）。メタのみ。配列は送らない。
 */

import api from './api';

export interface WorkspaceCatalogItem {
  clientKey: string;
  projectName: string;
  sequenceCount: number;
  totalBp: number;
  fileName: string | null;
  updatedAt: string;
}

export async function listWorkspaceCatalog(): Promise<WorkspaceCatalogItem[]> {
  const response = await api.get<{ success: boolean; data: WorkspaceCatalogItem[] }>(
    '/gene-analysis/workspace-catalog'
  );
  return response.data.data ?? [];
}

export async function syncWorkspaceCatalog(payload: {
  clientKey: string;
  projectName: string;
  sequenceCount: number;
  totalBp: number;
  fileName?: string;
}): Promise<WorkspaceCatalogItem> {
  const response = await api.post<{ success: boolean; data: WorkspaceCatalogItem }>(
    '/gene-analysis/workspace-catalog',
    payload
  );
  return response.data.data;
}
